import { Http } from '@/lib/http';
import SecureLS from 'secure-ls';

const ls = new SecureLS({ isCompression: false });
export class DelinquencyPoolService extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/app/case-management';
  }

  /**
   * Get delinquency loans 
   */
  fetchDelinquentLoans(query) {
    return this.httpClient().get(`${this.endpoint}/cases?${query}`);
  }

  fetchCaseHistory(query) {
    return this.httpClient().get(`${this.endpoint}/cases?${query}`);
  }

  deleteDelinquentLoan(id) {
    return this.httpClient().delete(`${this.endpoint}/id`);
  }
  
  /**
   * Get excel report based on the filters provided 
   */
  exportToExcel(query) {
    return this.httpClient().get(`${this.endpoint}/reports/excel${query}`, { responseType: 'arraybuffer' });
  }

  exportCaseHistoryToExcel(query) {
    return this.httpClient().get(`${this.endpoint}/reports/excel${query}`, {
      responseType: 'arraybuffer'
    });
  }

  /**
   * Used to set the columns that are marked as visible on the delinquency-pool
   * datatable in localstorage
   * @param { VuetifyDataTableColumns } columns - visible columns
   */
  static setVisibleColumns(columns) {
    ls.set('delinquency-pool:columns', JSON.stringify(columns));
  }

  /**
   * Used to get the columns that are marked as visible on the delinquency-pool
   * datatable from localstorgane
   * @return { VuetifyDataTableColumns } columns - visible columns
   */
  static getVisibleColumns() {
    const columns = ls.get('delinquency-pool:columns');
    return !columns ? [] : JSON.parse(columns);
  }
}

